/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ChannelSettingsDto } from './channel-settings-dto';
/**
 * 
 * @export
 * @interface PreferenceUpdateItem
 */
export interface PreferenceUpdateItem {
  _id?: string;
    /**
     * The notification type to configure
     * @type {string}
     * @memberof PreferenceUpdateItem
     */
    type: PreferenceUpdateItemTypeEnum;
    /**
     * Channel settings for this type
     * @type {ChannelSettingsDto}
     * @memberof PreferenceUpdateItem
     */
    settings: ChannelSettingsDto;
}

/**
    * @export
    * @enum {string}
    */
export enum PreferenceUpdateItemTypeEnum {
    ORDERCONFIRMATION = 'ORDER_CONFIRMATION',
    PAYMENTFAILED = 'PAYMENT_FAILED',
    ORDERSHIPPED = 'ORDER_SHIPPED',
    ORDERDELIVERED = 'ORDER_DELIVERED',
    REFUNDPROCESSED = 'REFUND_PROCESSED',
    REVIEWREPLY = 'REVIEW_REPLY',
    ABANDONEDCARTREMINDER = 'ABANDONED_CART_REMINDER',
    PRICEDROPALERT = 'PRICE_DROP_ALERT',
    BACKINSTOCK = 'BACK_IN_STOCK',
    PASSWORDRESET = 'PASSWORD_RESET',
    NEWDEVICELOGIN = 'NEW_DEVICE_LOGIN',
    TWOFACODE = 'TWO_FA_CODE',
    NEWORDER = 'NEW_ORDER',
    LOWSTOCKWARNING = 'LOW_STOCK_WARNING',
    NEWRETURNREQUEST = 'NEW_RETURN_REQUEST',
    NEWUSERREGISTERED = 'NEW_USER_REGISTERED',
    HIGHVALUEORDERALERT = 'HIGH_VALUE_ORDER_ALERT',
    PAYOUTFAILED = 'PAYOUT_FAILED',
    ORDERSTATUSUPDATED = 'ORDER_STATUS_UPDATED',
    INVOICEPAYMENTREQUIRED = 'INVOICE_PAYMENT_REQUIRED'
}

